import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Partner = () => {
  return (
    <div className="partner-usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="partner_content">
              <h2>
                How TekRevol Game Development Services Transform Your Game's
                Success
              </h2>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Discover how TekRevol makes your game a hit with our game
              development services. We begin by thoroughly understanding your
              concept, target audience, and unique features. As a trusted Unity
              game development company, we leverage Unity's powerful tech to
              create smooth and awesome games, ensuring your game stands out in
              the gaming world.
            </p>
          </Col>
        </Row>
        <Row className="h-100 partner_padd">
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on Clutch</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">4.8</div>
            <div className="partner-para">
              <p>Average Review Rating on RightFirms</p>
            </div>
          </Col>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <div className="partner-num">5.0</div>
            <div className="partner-para">
              <p>Average Review Rating on GoodFirms</p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Partner;
